import { ControlledSelectOption } from "ui";

import { DateTime } from "luxon";

// Formats a time as "08:00 AM" so every label has the same width
export const formatStartTimeLabel = (time: DateTime): string =>
  time.toFormat("hh:mm a");

// Minutes since midnight, used to compare times of day while ignoring dates
export const getMinutesOfDay = (time: DateTime): number =>
  time.hour * 60 + time.minute;

export const generateHourOptions = (
  restrictPastTimes = false,
  intervalMinutes = 60,
): ControlledSelectOption[] => {
  const options: ControlledSelectOption[] = [];
  const padWithZero = (num: number): string => num.toString().padStart(2, "0");

  // Get the current time of day only (ignore date)
  const currentMinutesOfDay = getMinutesOfDay(DateTime.local());

  for (let i = 0; i < 24 * 60; i += intervalMinutes) {
    const hour24 = Math.floor(i / 60);
    const minute = i % 60;
    const hour = hour24 % 12 === 0 ? 12 : hour24 % 12;
    const period = hour24 < 12 ? "AM" : "PM";

    // Only compare time of day - ignore dates entirely
    // A slot is considered past if it starts at or before the current time
    const isInPast = restrictPastTimes && i <= currentMinutesOfDay;

    options.push({
      value: `${padWithZero(hour24)}:${padWithZero(minute)}`,
      label: `${padWithZero(hour)}:${padWithZero(minute)} ${period}`,
      disabled: isInPast,
    });
  }

  return options;
};

export const convertIsoToFullDateAndTime = (
  isoDate: string | undefined | null,
) => {
  if (!isoDate) return;
  return DateTime.fromISO(isoDate).toFormat("MM/dd/yyyy, hh:mm a");
};

// Local wall-clock stamp for download names: 2026-10-02_09-35-11.
// Hyphens keep the time intact; colons get rewritten to underscores by the browser.
export const localFileTimestamp = (): string =>
  DateTime.local().toFormat("yyyy-MM-dd_HH-mm-ss");
